import React from 'react';
import { Modal, Text, Group } from '@mantine/core';

import { UploadedFileResponse } from '../models/responses/UploadedFileResponse';
import DocumentPreviewPane from './DocumentPreviewPane';

interface Props {
    file: UploadedFileResponse | any | null;
    isOpen: boolean;
    onClose: () => void;
    initialPage?: number;
    sourceUrlOverride?: string;
}

const getSafeName = (file: any) => file?.FileName ?? file?.fileName ?? '';

// NOTE: the header no longer links to the document's storage URL. The document
// is fetched through our authenticated endpoint inside DocumentPreviewPane,
// which exposes its own download action (and the PDF viewer toolbar has one),
// so linking here would mean downloading the file a second time.
const DocumentPreviewModal = ({ file, isOpen, onClose, initialPage }: Props) => {
    const name = getSafeName(file);

    return (
        <Modal
            opened={isOpen}
            onClose={onClose}
            title={
                <Group>
                    <Text truncate style={{ maxWidth: 300 }}>
                        {file ? `Preview: ${name || '(no name)'}` : 'Preview'}
                    </Text>
                </Group>
            }
            size="90%"
            radius="md"
            centered
            styles={{
                content: { height: '90vh', maxHeight: '90vh', overflow: 'hidden' },
                body: { height: 'calc(90vh - 60px)', padding: 0 },
            }}
        >
            <DocumentPreviewPane file={file} initialPage={initialPage} />
        </Modal>
    );
};

export default DocumentPreviewModal;
